import React, { useState } from 'react';

import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { crmValidator, alert as customAlert  } from 'helpers';
import lodash from 'lodash';

import moment from "moment";

// material-ui components
import withStyles from "@material-ui/core/styles/withStyles";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import Button from "components/CustomButtons/Button.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import CustomSelect from "components/CustomSelect/CustomSelect.jsx";
import CustomDatePicker from "components/CustomDatePicker/CustomDatePicker.jsx";
import { formValueSelector } from 'redux-form';

import modalStyle from "assets/jss/material-dashboard-pro-react/modalStyle.jsx";

import { alert, store, plugins } from 'helpers';
import { earnSpecialsConstants,surveyConstants } from '../../constants';

import { surveyAction, memberActions } from 'actions';
import * as FormValidator from './validate/FormValidator';

// Condition
import FormPoint from "./FormCondition/FormPoint.jsx";

// Reward
import FormRewardPoint from "./FormReward/FormRewardPoint.jsx";
import Form3rdPartyCode from "./FormReward/Form3rdPartyCode.jsx";

// material jss
import { cardTitle } from "assets/jss/material-dashboard-pro-react.jsx";

import TagsMultiSelect from "components/CustomSelect/TagsMultiSelect.jsx";
import i18n from "i18n";

const FORM_NAME = "FORM_EARNSPECIALS";
const dbDateFormat = "YYYY-MM-DDTHH:mm:ss.sssZ";
const selector = formValueSelector(FORM_NAME);


const style = {
	customCardContentClass: {
		paddingLeft: "0",
		paddingRight: "0",
	},
	cardIconTitle: {
		...cardTitle,
		marginTop: "15px",
		marginBottom: "0px",
	},
	cardFooter: {
		padding: "15px",
		textAlign: "right",
		paddingTop: "0",
		margin: "0",
	},
	labelHorizontalCenter: {
		float: "right",
		color: "rgba(0, 0, 0, 0.26)",
		cursor: "pointer",
		display: "inline-flex",
		fontSize: "14px",
		lineHeight: "1.428571429",
		fontWeight: "400",
		paddingTop: "39px",
		marginRight: "0",
	},
	checkboxAndRadio: {
		position: "relative",
		display: "block",
		marginTop: "10px",
		marginBottom: "10px",
	},
	checkboxAndRadioHorizontal: {
		position: "relative",
		display: "block",
		"&:first-child": {
			marginTop: "10px",
		},
		"&:not(:first-child)": {
			marginTop: "-14px",
		},
		marginTop: "0",
		marginBottom: "0",
	},
	paddingLeft32: {
		paddingLeft: "32px",
	},
	borderDashed: {
		border: "dashed 1px rgb(119 116 116)",
		padding: "20px 20px",
		width: "100%",
		margin: "15px 15px",
	},
};


class CreateSubSurveyForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
          numberAnswerSet: 0,

        };

      }

      handleNumberAnswerChange = (event, newValue) => {
        const selectedValue = event.target.value || newValue; // In case the value is passed directly
        this.setState({ numberAnswerSet: parseInt(selectedValue, 10) }); // Ensure it's a number
        console.log("handleNumberAnswerChange", selectedValue);
    };  

	handleSubmit = (values) => {

		const { dispatch, tableSubSurveyData, initialValues } = this.props;	
        
        //console.log("sub surveyform formmode ",this.props.formMode) 
        
        // Initialize an errors object to hold validation messages

        const errors = {};

        // Validate `questionType` field
        if (!values.questionType) {
            errors.questionType = "Question Type is required";
            customAlert(dispatch, 'error', errors.questionType);
            return;
        }

        // Validate `question` field
        if (!values.question) {
            errors.question = "Question is required";
            customAlert(dispatch, 'error', errors.question);
            return;
        }



        // Validate `question` field
        if (!values.questionOrder) {
            errors.question = "Question No is required";
            customAlert(dispatch, 'error', errors.question);
            return;
        }else {

            // Convert `values.questionOrder` to an integer for comparison
            const questionOrderInt = parseInt(values.questionOrder, 10);
            const initialQuestionOrderInt = parseInt(initialValues.questionOrder, 10); // Convert initial value

            if (questionOrderInt !== initialQuestionOrderInt) {

                // Loop through tableSubSurveyData.subSurvey to check for duplicate questionOrder
                const isDuplicateOrder = tableSubSurveyData.subSurvey.some(subSurvey => parseInt(subSurvey.questionOrder, 10) === questionOrderInt);
    
                if (isDuplicateOrder) {
                    errors.questionOrder = `Question No ${values.questionOrder} is already in use.`;
                    customAlert(dispatch, 'error', errors.questionOrder);
                    return;
                }
                
            }

        }



        // Validate `status_subsurvey` field
        if (!values.status_subsurvey) {
            errors.question = "Status is required";
            customAlert(dispatch, 'error', errors.question);
            return;
        }



        // Validate `numberAnswer` field
        if (!values.numberAnswer && (values.questionType === 'close' || values.questionType === 'ranking')) {
            errors.numberAnswer = "No of answers is required";
            customAlert(dispatch, 'error', errors.numberAnswer);
            return;
        }



        // Validate `numberAnswer` field
        if (values.numberAnswer) {
            // Loop from 1 to `values.numberAnswer`
            for (let i = 1; i <= values.numberAnswer; i++) {
                const answerKey = `answer${i}`; // Assuming answers are stored as answer1, answer2, etc.

                // Check if each answer field is empty or undefined
                if (!values[answerKey]) {
                    errors[answerKey] = `Choice ${i} is required`;
                    customAlert(dispatch, 'error', errors[answerKey]);
                    return;
                }
            }
        } 



        // Validate `numberSelectAnswer` field
        if (!values.numberSelectAnswer && values.questionType === 'close') {
            errors.numberSelectAnswer = "No of selective answers is required";
            customAlert(dispatch, 'error', errors.numberSelectAnswer);
            return;
        }

        // If there are errors, do not proceed with the form submission
        if (Object.keys(errors).length > 0) {
            console.log("Form has errors:", errors);
            return errors;
        }

        let data = lodash.clone(values) 
        console.log('sub surveyform  data:',data);

		// if (this.props.formMode === "add") {

        //     dispatch(surveyAction.addSubSurvey(data));
		// } else {
		// 	dispatch(surveyAction.updateSubSurvey(data));
		// }
		
		// dispatch(surveyAction.getSurveyById(initialValues._idSurvey))

        // Define a function to dispatch the survey retrieval after success
        const handleSurveyById = () => {
            dispatch(surveyAction.getSurveyById(initialValues._idSurvey));
        };

		if (this.props.formMode === "add") {

            //dispatch(surveyAction.addSubSurvey(data));
            dispatch(surveyAction.addSubSurvey(data))
            .then(handleSurveyById); // Fetch survey after success
		} else {
			//dispatch(surveyAction.updateSubSurvey(data));
            dispatch(surveyAction.updateSubSurvey(data))
            .then(handleSurveyById); // Fetch survey after success
		}
		
	};

    

    componentDidMount() {
        const { dispatch, FORM_EARNSPECIALS,formInitialValue,formMode }  = this.props;

        dispatch(surveyAction.fetchSurveyList());

        dispatch(memberActions.getActiveTagList());
		dispatch(memberActions.getActiveMemberLevelList());
 
         console.log("componentDidMount", this.state.numberAnswerSet);
    }


    
    render() {
        
        const { formOpen, formMode, classes, dispatch, handleSubmit, FORM_EARNSPECIALS, surveyList, formValues, trdPartyCodeSet, formMemberLevellist, formTaglist, initialNumberAnswer, initialQuestionType, initialId } = this.props
        const { numberAnswerSet} = this.state       
        let { readOnly } = this.props
        let initialNumberAnswerNum = Number(initialNumberAnswer);
        
        if ((!initialNumberAnswerNum || isNaN(initialNumberAnswerNum)) && formMode === 'edit') {
            initialNumberAnswerNum = 1;
        }

        const effectiveNumberAnswer = numberAnswerSet > 0 ? numberAnswerSet : (initialNumberAnswerNum > 0 ? initialNumberAnswerNum : 1);

        if (formMode === `add`) {
            readOnly = false
        } else if (formMode === `edit` && !readOnly) {
            readOnly = false
        } else {
            readOnly = true
        }

        const listRewardType = [
            { value: "3rdPartyCode", label: "3rd party Code" },
            { value: "point", label: "Add Point" }

        ]

        let componentReward = null;
        let selTrdPartyValue = [];

        const surveyOptions = Array.isArray(surveyList.surveys) ? 
        surveyList.surveys.map(survey => ({ value: survey._id, label: survey.name })) : [];
        
        const { questionType, numberSelectAnswer } = formValues || {};

        return (
            <Dialog
                classes={{
                    root: classes.center,
                    paper: classes.modal
                }}
                open={formOpen}
                keepMounted
                aria-labelledby="modal-slide-title"
                aria-describedby="modal-slide-description"
                fullWidth={true}
                maxWidth={"lg"}
                disableRestoreFocus={true}
                scroll="body">

                <DialogTitle
                    disableTypography
                    className={classes.modalHeader}>
                    <h4 className={classes.modalTitle}><b>{formMode === 'add' ? 'Create Question' : (readOnly ? 'Special Info' : 'Edit Question')}</b></h4>
                </DialogTitle>

                <form name={FORM_NAME} onSubmit={handleSubmit(this.handleSubmit)}>
                    <DialogContent className={classes.modalBody}>

                        <GridContainer>
                            
                            <GridItem xs={12} sm={6} md={4}>
                                <Field
                                    id='question-type-select'
                                    name="questionType"
                                    component={CustomSelect}
                                    type="text"
                                    labelText="Question Type *"
                                    formControlProps={{
                                        fullWidth: true
                                    }}
                                    optionsList={[
                                        {value: "open",label: "Open-ended questions"},
                                        {value: "close",label: "Close-ended questions"},   
                                        {value: "rating",label: "Rating"},  
                                        {value: "ranking",label: "Ranking"},                                   
                                    ]}
                                    disabled={readOnly}
                                />
                            </GridItem>
                    
                        </GridContainer>

                        <GridContainer>
                            <GridItem xs={12} sm={6} md={8}>
                                
                                <Field
                                        id='question-id-input'
                                        name="surveyId"
                                        component="input"
                                        type="hidden"
                                    />
                                {formMode === "edit" ?
                                    <Field
                                        id='question-id-input'
                                        name="_id"
                                        component="input"
                                        type="hidden"
                                    />
                                    : null}
                            </GridItem>
                        </GridContainer> 

                        <GridContainer>
                            <GridItem xs={12} sm={6} md={8}>
                                <Field
                                    id='question-input'
                                    name="question"
                                    component={CustomInput}
                                    type="text"
                                    labelText="Question *"
                                    formControlProps={{
                                        fullWidth: true
                                    }}
                                    disabled={readOnly}
                                />
                                {formMode === "edit" ?
                                    <Field
                                        id='question-id-input'
                                        name="_id"
                                        component="input"
                                        type="hidden"
                                    />
                                    : null}
                            </GridItem>
                            
                        </GridContainer>
                        
                        <GridContainer>
                            <GridItem xs={12} sm={6} md={8}>
                                <Field
                                    id='question-order-input'
                                    name="questionOrder"
                                    component={CustomInput}
                                    type="text"
                                    labelText="Question No *"
                                    formControlProps={{
                                        fullWidth: true
                                    }}
                                    disabled={readOnly}
                                />
                            </GridItem>
                            
                        </GridContainer>                      

                        {questionType !== "open" && questionType !== "rating" && ( 

                        <GridContainer>
                            
                            <GridItem xs={12} sm={6} md={4}>
                                <Field
                                    id='number-answer-select'
                                    name="numberAnswer"
                                    component={CustomSelect}
                                    type="text"
                                    labelText="No. of answer *"
                                    formControlProps={{
                                        fullWidth: true
                                    }}
                                    optionsList={[   
                                       
                                        {value: "1", label: "1"},
                                        {value: "2", label: "2"},  
                                        {value: "3", label: "3"},  
                                        {value: "4", label: "4"}, 
                                        {value: "5", label: "5"}, 
                                        {value: "6", label: "6"}, 
                                        {value: "7", label: "7"}, 
                                        {value: "8", label: "8"}, 
                                        {value: "9", label: "9"}, 
                                        {value: "10", label: "10"},
                                        {value: "11", label: "11"},
                                        {value: "12", label: "12"},
                                        {value: "13", label: "13"},
                                        {value: "14", label: "14"},
                                        {value: "15", label: "15"},
                                                                      
                                    ]}
                                    disabled={readOnly}
                                   
                                    onChange={this.handleNumberAnswerChange}
                                />
                            </GridItem>

                        </GridContainer>
                        
                        )}

                        {questionType !== "open" && questionType !== "rating" && questionType !== "ranking" && (

                        <GridContainer>
                            
                            <GridItem xs={12} sm={6} md={4}>
                                <Field
                                    id='number-select-answer-select'
                                    name="numberSelectAnswer"
                                    component={CustomSelect}
                                    type="text"
                                    labelText="No. of selective answer *"
                                    formControlProps={{
                                        fullWidth: true
                                    }}
                                    optionsList={[
                                        {value: "single",label: "Single"},
                                        {value: "multiple",label: "Multiple"},      
                                                                      
                                    ]}
                                    disabled={readOnly}
                                />
                            </GridItem>

                        </GridContainer>
                        
                        )}

                        <GridContainer>
                            
                            <GridItem xs={12} sm={6} md={4}>
                                <Field
                                    id='status-select'
                                    name="status_subsurvey"
                                    component={CustomSelect}
                                    type="text"
                                    labelText="Status *"
                                    formControlProps={{
                                        fullWidth: true
                                    }}
                                    optionsList={[
                                        {value: "active",label: "Active"},
                                        {value: "inactive",label: "Inactive"},   
                                                                        
                                    ]}
                                    disabled={readOnly}
                                />
                            </GridItem>
                    
                        </GridContainer>                           

                        {/* {questionType !== "open" && ( */}

                        {questionType !== "open" && questionType !== "rating" && (

                         [...Array(effectiveNumberAnswer)].map((_, index) => ( 
                         
                                <GridContainer key={index}>
                                    <GridItem xs={12} sm={6} md={8}>
                                        <Field
                                            id={`answer${index + 1}-input`}
                                            name={`answer${index + 1}`}
                                            component={CustomInput}
                                            type="text"
                                            labelText={`Choice ${index + 1} *`}
                                            formControlProps={{
                                                fullWidth: true
                                            }}
                                            disabled={readOnly}
                                        />
                                    </GridItem>

                                     
                                    { questionType !== "ranking" && numberSelectAnswer == "single" && (              
                                    <GridItem xs={12} sm={6} md={4}>  
                                        <Field
                                            id={`givePoint${index + 1}-input`}
                                            name={`givePoint${index + 1}`}
                                            component={CustomInput}
                                            type="text"
                                            labelText={`Give Points ${index + 1} `}
                                            formControlProps={{
                                                fullWidth: true
                                            }}
                                            disabled={readOnly}
                                            // normalize={(value) => value === '' || value == null ? '0' : value}
                                            normalize={(value) => value}
                                            defaultValue="0"
                                        />
                                    </GridItem>
                                    )}

                                </GridContainer>
                         ))

                        )}  

                        
                    </DialogContent>

                    <DialogActions
                        className={classes.modalFooter}>
                        {!readOnly ?

                            <Button
                                id='submit-sub-survey-btn'
                                type="button"
                                onClick={() => {

                                    const { formValues } = this.props;
                                    this.handleSubmit(formValues);
                                }}
                                style={{ marginRight: "10px" }}
                                color="primary">
                                {formMode === "edit" ? "Update" : "Submit"}
                            </Button>
                            : ''
                        }
                        <Button
                            id='cancel-btn'
                            type="button"
                            onClick={() => {
                                dispatch({ type: surveyConstants.CLOSE_FORM_SUB_SURVEY });
                                this.setState({ numberAnswerSet: 0 });
                            }}
                            color="white">
                            Cancel
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>
        )
    }

}

function mapStateToProps(state) {
    
    const formValues = selector(state, 'questionType', 'surveyId','_id', 'question', 'questionOrder', 'numberAnswer', 'numberSelectAnswer',
                               'answer1', 'answer2', 'answer3', 'answer4', 'answer5', 'answer6', 'answer7', 'answer8', 'answer9', 'answer10', 'answer11', 'answer12', 'answer13', 'answer14', 'answer15',
                               'givePoint1', 'givePoint2', 'givePoint3', 'givePoint4', 'givePoint5', 'givePoint6', 'givePoint7', 'givePoint8', 'givePoint9', 'givePoint10', 'givePoint11', 'givePoint12', 'givePoint13', 'givePoint14', 'givePoint15',
                               'status_subsurvey');
    const { formOpen, formMode, surveyList, productList, allProductList, joinedProductRows, joinedProductList, allShopListSelected, productListMaster,trdPartyCodeSet, rewardImagePreview, numberAnswerSet } = state.survey;
    const { FORM_EARNSPECIALS } = state.form;
    const { formTaglist, formMemberLevellist } = state.member;
    const { package_features } = state.authentication
    return {
        formOpen, formMode, FORM_EARNSPECIALS, surveyList, allProductList, productList, joinedProductRows, joinedProductList, allShopListSelected, productListMaster, package_features, trdPartyCodeSet, formTaglist, formMemberLevellist, rewardImagePreview, formValues, numberAnswerSet
    };
}

const connectCampaignForm = connect(mapStateToProps)(CreateSubSurveyForm);

export default reduxForm({
    form: FORM_NAME,
    enableReinitialize: true,
    onSubmitFail: (errors, dispatch, props) => {

        
    }
})(withStyles(modalStyle)(connectCampaignForm))
